(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/misc/spelguide.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/misc/spelguide.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.Spelguide = Marionette.View.extend({
    template: function(data) {
      return svs.bingo.templates.spelguide(data);
    },
    ui: {
      tabViewContainer: '#spelguide-tabview'
    },
    tabView: undefined,
    tabViews: [],
    availableTickets: undefined,
    gameTypeRegexp: /spela\/(\d*?)($|\/)/,

    initialize: function(options) {
      this.availableTickets = options.availableTickets;
      this.tabView = undefined;
      this.tabViews = [];
      this.initTabs();
    },

    onRender: function() {
      var gameType = this.gameTypeRegexp.exec(Backbone.history.getFragment()),
        self = this;

      if (gameType && gameType[1]) {
        svs.bingo.nyxChannel
          .request('gameById', +gameType[1])
          .then(function(game) {
            self.renderTabView('tab-spelguide' + game.playmode.toLowerCase());
          });
      } else {
        this.renderTabView();
      }
    },

    renderTabView: function(selected) {
      this.tabView = new svs.app.tab_view.TabView({
        tabs: this.tabViews,
        el: this.$('#spelguide-tabview'),
        sliderOptions: {
          deeplinking: {
            enabled: false,
            change: true
          }
        },
        noDetectActiveTab: true,
        selected: this.options.selectedTab || selected,
        doubleWidth: true
      });

      this.tabView.on(
        'sizeUpdated',
        function() {
          this.trigger('modalContentResize');
        },
        this
      );

      this.tabView.on(
        'onChange',
        function() {
          this.trigger('modalContentResize');
        },
        this
      );
    },

    initTabs: function() {
      var idPrefix = 'tab-spelguide',
        classNames = 'padding-1';

      if (!this.tabViews.length) {
        this.tabViews.push({
          caption: 'Multispel',
          view: new Marionette.View({
            template: svs.bingo.templates.multispel,
            className: classNames
          }),
          id: idPrefix + 'multiuser'
        });

        this.tabViews.push({
          caption: 'Singelspel',
          view: new Marionette.View({
            template: svs.bingo.templates.singelspel,
            className: classNames
          }),
          id: idPrefix + 'singleuser'
        });

        this.tabViews.push({
          caption: 'Vinstplan',
          view: new Marionette.View({
            template: svs.bingo.templates.vinstplan,
            className: classNames
          }),
          id: idPrefix + 'winnings'
        });
      }
    },
    onDestroy: function() {
      if (window.location.pathname.indexOf('spelguide') !== -1) {
        svs.bingo.router.navigate('/', { trigger: false });
      }
    }
  });
})(Backbone, _, svs);


 })(window);